import { useApiClient } from '@/composables/useApiClient'
import { CategorySortKey, FilterTypes } from '@/constants/filters'

const getDefaultState = () => {
  return {
    filters: {},
    filterTags: {},
  }
}

export const state = () => getDefaultState()

export const getters = {
  sortType: state => {
    return state.filters[FilterTypes.SORTBY] ?? CategorySortKey.POPULAR
  },
  filters: state => state.filters,
  filterTags: state => state.filterTags,
}

export const actions = {
  resetFilterState({ commit }) {
    commit('RESET_FILTER_STATE')
  },
  async getFilters({ commit }, { categoryID, regionID, sub_category_id }) {
    const params = { category_id: categoryID, region_id: regionID, sub_category_id }
    const url = `/filters`
    const res = await useApiClient().$get(url, { params: params })
    return res
  },
  setSortType({ commit }, { sortType }) {
    commit('SET_SORT_TYPE', sortType)
  },
  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },
  resetAndSetFilters({ commit }, filters) {
    commit('RESET_FILTER_STATE')
    commit('SET_FILTERS', filters)
  },
  setFilterTags({ commit }, filterTags) {
    commit('SET_FILTER_TAGS', filterTags)
  },
}

export const mutations = {
  RESET_FILTER_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_SORT_TYPE(state, sortType) {
    state.filters[FilterTypes.SORTBY] = sortType
  },
  SET_FILTERS(state, filters) {
    const filterMap = Object.assign({}, state.filters)
    for (const name in filters) {
      if (filters[name]) {
        filterMap[name] = filters[name]
      } else {
        delete filterMap[name]
      }
    }
    state.filters = Object.assign({}, { ...filterMap })
  },
  SET_FILTER_TAGS(state, filterTags) {
    state.filterTags = Object.assign({}, state.filterTags, { ...filterTags })
  },
}
